const Iletisim = resolve => {
    require.ensure(['../views/apps/iletisim/Iletisim'], () => {
        resolve(require('../views/apps/iletisim/Iletisim'))
    })
};
const IletisimListesi = resolve => {
    require.ensure(['../views/apps/iletisim/IletisimListesi'], () => {
        resolve(require('../views/apps/iletisim/IletisimListesi'))
    })
};
const Ayar = resolve => {
    require.ensure(['../views/apps/iletisim/ayar/Ayar'], () => {
        resolve(require('../views/apps/iletisim/ayar/Ayar'))
    })
};

const AyarIslem = resolve => {
    require.ensure(['../views/apps/iletisim/ayar/AyarIslem'], () => {
        resolve(require('../views/apps/iletisim/ayar/AyarIslem'))
    })
};


import layouts from '../layout'

export default {
    path: '/iletisim',
    name: 'iletisim',
    component: Iletisim,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'liste',
            name: 'iletisimListesi',
            component: IletisimListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'ayarlar',
            name: 'iletisimayar',
            component: AyarIslem,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ],

}
